import { saveAs } from "file-saver";
import { axiosInstance } from "./AxiosService";

export default class MediaHelper {
    public static getFileNameFromResponse(response: any) {
        const disposition = response.headers["content-disposition"];
        if (!disposition || disposition.indexOf("attachment") === -1) {
            return null;
        }
        const matches = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, "");
        }
        return null;
    }

    public static downloadMediaItem(sitecoreId: string, dbName?: string) {
        if (sitecoreId === null || sitecoreId.match(/^\s*$/)) {
            return new Promise<boolean>((resolve) => {
                resolve(false);
            });
        }
        return axiosInstance({
            method: "GET",
            responseType: "blob",
            url: `GetMediaItemFile?sitecoreId=${sitecoreId}${dbName ? `&dbName=${dbName}` : ""}`,
        }).then((response) => {
            if (!response) {
                return false;
            }
            const fileName = MediaHelper.getFileNameFromResponse(response);
            saveAs(new Blob([response.data]), fileName ? fileName : "document");
            return true;
        }).catch(() => {
            return false;
        });
    }
}
